import React from 'react';
import {
  BrowserRouter,
  Routes,
  Route,
  Outlet,
  Navigate,
  useNavigate,

} from "react-router-dom";
import "./App.css"
import './Components/style.css'
import 'react-toastify/dist/ReactToastify.css';
import 'react-confirm-alert/src/react-confirm-alert.css';
import "react-datepicker/dist/react-datepicker.css";
import Login from './Components/Login/Login'

import AartiList from './Components/Aarti/Aartis';
import AddAarti from './Components/Aarti/AddAarti';
import EditAarti from './Components/Aarti/EditAarti';

import BhajanList from './Components/Bhajan/Bhajan';
import AddBhajan from './Components/Bhajan/AddBhajan';
import EditBhajan from './Components/Bhajan/EditBhajan';

import StrotraList from './Components/Strotra/Strotra';
import AddStrotra from './Components/Strotra/AddStrotra';
import EditStrotra from './Components/Strotra/EditStrotra';

import BhaktiList from './Components/Bhakti/Bhakti';
import AddBhakti from './Components/Bhakti/AddBhakti';
import EditBhakti from './Components/Bhakti/EditBhakti';

import PujaList from './Components/Puja/Puja';
import AddPuja from './Components/Puja/Addpuja';
import EditPuja from './Components/Puja/EditPuja';

import VartmanChaubisi from './Components/VartmanChaubisi/VartmanChaubisi';
import AddVartman from './Components/VartmanChaubisi/AddVartman';
import EditVartman from './Components/VartmanChaubisi/EditVartman';

import BhootkalChaubisi from './Components/BhootkalChaubisi/BhootkalChaubisi';
import AddBhootkal from './Components/BhootkalChaubisi/AddBhootkal';
import EditBhootkal from './Components/BhootkalChaubisi/EditBhootkal';

import BhavishyaChaubisi from './Components/BhavishyaChaubisi/BhavishyaChaubisi';
import AddBhavishya from './Components/BhavishyaChaubisi/AddBhavishya';
import EditBhavishya from './Components/BhavishyaChaubisi/EditBhavishya';

import VidhyamanChaubisi from './Components/VidhyamanChaubisi/VidhyamanChaubisi';
import AddVidhyaman from './Components/VidhyamanChaubisi/AddVidhyaman';
import EditVidhyaman from './Components/VidhyamanChaubisi/EditVidhyaman';

import AudioList from './Components/Audio/Audio';
import AddAudio from './Components/Audio/AddAudio';
import EditAudio from './Components/Audio/EditAudio';

import VideoList from './Components/Video/Video';
import AddVideo from './Components/Video/AddVideo';
import EditVideo from './Components/Video/EditVideo';

import ChalisaList from './Components/Chalisa/Chalisa';
import AddChalisa from './Components/Chalisa/AddChalisa';
import EditChalisa from './Components/Chalisa/EditChalisa';

import StutiList from './Components/Stuti/Stuti';
import AddStuti from './Components/Stuti/AddStuti';
import EditStuti from './Components/Stuti/EditStuti';

import ChangePass from './Components/Login/ChangePass';
import StoryList from './Components/Story/Story';
import AddStory from './Components/Story/AddStory';
import EditStory from './Components/Story/EditStory';
import ShortVideoList from './Components/ShortVideo/ShortVideo';
import AddShortVideo from './Components/ShortVideo/AddShortVideo';
import EditShortVideo from './Components/ShortVideo/EditShortVideo';
import KittiGamesList from './Components/KittiGames/KittiGames';
import AddKittiGames from './Components/KittiGames/AddKittiGames';
import EditKittiGames from './Components/KittiGames/EditKittiGames';
import MaharajList from './Components/Maharaj/Maharaj';
import AddMaharaj from './Components/Maharaj/AddMaharaj';
import EditMaharaj from './Components/Maharaj/EditMaharaj';
import SuvicharList from './Components/Suvichar/Suvichar';
import AddSuvichar from './Components/Suvichar/AddSuvichar';
import EditSuvichar from './Components/Suvichar/EditSuvichar';
import BhajanCategoryList from './Components/BhajanCategory/BhajanCategory';
import AddBhajanCategory from './Components/BhajanCategory/AddBhajanCategory';
import EditBhajanCategory from './Components/BhajanCategory/EditBhajanCategory';

function App() {
  const PageNotFound = () => {
    const navigate = useNavigate();
    return (
      <div className='vh-100 d-flex justify-content-center align-items-center flex-column'>
        <h1 className="text-danger">404 ERROR</h1>
        <h2>Page Not Found!</h2>
        <button className="btn btn-danger btn-sm" onClick={() => navigate(-1)}>Go Back</button>
      </div>
    )
  }
  
  
  
  const Authentication = () => (
    localStorage.getItem("user_token") && localStorage.getItem("user_id") ? <Outlet /> : <Navigate to="/" />
  )

  return (
    <BrowserRouter>

      <Routes>
        <Route path="/" element={<Login />}></Route>
        <Route path="/changepassword" element={<ChangePass />}></Route>


        <Route path="/menu/aartilist" element={<Authentication />}>
          <Route path="/menu/aartilist" element={<AartiList />} />
        </Route >


        <Route path="/menu/addaarti" element={<Authentication />} >
          <Route path="/menu/addaarti" element={<AddAarti />} />
        </Route >


        <Route path="/menu/editaarti/:id" element={<Authentication />} >
          <Route path="/menu/editaarti/:id" element={<EditAarti />} />
        </Route >



        <Route path="/menu/chalisalist" element={<Authentication />} >
          <Route path="/menu/chalisalist" element={<ChalisaList />} />
        </Route >


        <Route path="/menu/addchalisa" element={<Authentication />} >
          <Route path="/menu/addchalisa" element={<AddChalisa />} />
        </Route >


        <Route path="/menu/editchalisa/:id" element={<Authentication />} >
          <Route path="/menu/editchalisa/:id" element={<EditChalisa />} />
        </Route >




        <Route path="/menu/bhajanlist" element={<Authentication />} >
          <Route path="/menu/bhajanlist" element={<BhajanList />} />
        </Route >


        <Route path="/menu/addbhajan" element={<Authentication />} >
          <Route path="/menu/addbhajan" element={<AddBhajan />} />
        </Route >


        <Route path="/menu/editbhajan/:id" element={<Authentication />} >
          <Route path="/menu/editbhajan/:id" element={<EditBhajan />} />
        </Route >



        <Route path="/menu/bhajancategorylist" element={<Authentication />} >
          <Route path="/menu/bhajancategorylist" element={<BhajanCategoryList />} />
        </Route >


        <Route path="/menu/addbhajancategory" element={<Authentication />} >
          <Route path="/menu/addbhajancategory" element={<AddBhajanCategory />} />
        </Route >


        <Route path="/menu/editbhajancategory/:id" element={<Authentication />} >
          <Route path="/menu/editbhajancategory/:id" element={<EditBhajanCategory />} />
        </Route >



        <Route path="/menu/stutilist" element={<Authentication />} >
          <Route path="/menu/stutilist" element={<StutiList />} />
        </Route >


        <Route path="/menu/addstuti" element={<Authentication />} >
          <Route path="/menu/addstuti" element={<AddStuti />} />
        </Route >


        <Route path="/menu/editstuti/:id" element={<Authentication />} >
          <Route path="/menu/editstuti/:id" element={<EditStuti />} />
        </Route >



        <Route path="/menu/strotralist" element={<Authentication />} >
          <Route path="/menu/strotralist" element={<StrotraList />} />
        </Route >


        <Route path="/menu/addstrotra" element={<Authentication />} >
          <Route path="/menu/addstrotra" element={<AddStrotra />} />
        </Route >


        <Route path="/menu/editstrotra/:id" element={<Authentication />} >
          <Route path="/menu/editstrotra/:id" element={<EditStrotra />} />
        </Route >



        <Route path="/menu/bhaktilist" element={<Authentication />} >
          <Route path="/menu/bhaktilist" element={<BhaktiList />} />
        </Route >


        <Route path="/menu/addbhakti" element={<Authentication />} >
          <Route path="/menu/addbhakti" element={<AddBhakti />} />
        </Route >


        <Route path="/menu/editbhakti/:id" element={<Authentication />} >
          <Route path="/menu/editbhakti/:id" element={<EditBhakti />} />
        </Route >




        <Route path="/menu/pujalist" element={<Authentication />} >
          <Route path="/menu/pujalist" element={<PujaList />} />
        </Route >


        <Route path="/menu/addpuja" element={<Authentication />} >
          <Route path="/menu/addpuja" element={<AddPuja />} />
        </Route >


        <Route path="/menu/editpuja/:id" element={<Authentication />} >
          <Route path="/menu/editpuja/:id" element={<EditPuja />} />
        </Route >



        <Route path="/vartmanlist" element={<Authentication />} >
          <Route path="/vartmanlist" element={<VartmanChaubisi />} />
        </Route >


        <Route path="/addvartman" element={<Authentication />} >
          <Route path="/addvartman" element={<AddVartman />} />
        </Route >


        <Route path="/editvartman/:id" element={<Authentication />} >
          <Route path="/editvartman/:id" element={<EditVartman />} />
        </Route >



        <Route path="/bhootkallist" element={<Authentication />} >
          <Route path="/bhootkallist" element={<BhootkalChaubisi />} />
        </Route >


        <Route path="/addbhootkal" element={<Authentication />} >
          <Route path="/addbhootkal" element={<AddBhootkal />} />
        </Route >


        <Route path="/editbhootkal/:id" element={<Authentication />} >
          <Route path="/editbhootkal/:id" element={<EditBhootkal />} />
        </Route >



        <Route path="/bhavishyalist" element={<Authentication />} >
          <Route path="/bhavishyalist" element={<BhavishyaChaubisi />} />
        </Route >


        <Route path="/addbhavishya" element={<Authentication />} >
          <Route path="/addbhavishya" element={<AddBhavishya />} />
        </Route >


        <Route path="/editbhavishya/:id" element={<Authentication />} >
          <Route path="/editbhavishya/:id" element={<EditBhavishya />} />
        </Route >



        <Route path="/vidhyamanlist" element={<Authentication />} >
          <Route path="/vidhyamanlist" element={<VidhyamanChaubisi />} />
        </Route >


        <Route path="/addvidhyaman" element={<Authentication />} >
          <Route path="/addvidhyaman" element={<AddVidhyaman />} />
        </Route >


        <Route path="/editvidhyaman/:id" element={<Authentication />} >
          <Route path="/editvidhyaman/:id" element={<EditVidhyaman />} />
        </Route >



        <Route path="/menu/audiolist" element={<Authentication />} >
          <Route path="/menu/audiolist" element={<AudioList />} />
        </Route >


        <Route path="/menu/addaudio" element={<Authentication />} >
          <Route path="/menu/addaudio" element={<AddAudio />} />
        </Route >


        <Route path="/menu/editaudio/:id" element={<Authentication />} >
          <Route path="/menu/editaudio/:id" element={<EditAudio />} />
        </Route >



        <Route path="/menu/videolist" element={<Authentication />} >
          <Route path="/menu/videolist" element={<VideoList />} />
        </Route >


        <Route path="/menu/addvideo" element={<Authentication />} >
          <Route path="/menu/addvideo" element={<AddVideo />} />
        </Route >


        <Route path="/menu/editvideo/:id" element={<Authentication />} >
          <Route path="/menu/editvideo/:id" element={<EditVideo />} />
        </Route >


        <Route path="/menu/storylist" element={<Authentication />} >
          <Route path="/menu/storylist" element={<StoryList />} />
        </Route >


        <Route path="/menu/addstory" element={<Authentication />} >
          <Route path="/menu/addstory" element={<AddStory />} />
        </Route >


        <Route path="/menu/editstory/:id" element={<Authentication />} >
          <Route path="/menu/editstory/:id" element={<EditStory />} />
        </Route >
       
       
        <Route path="/menu/shortvideolist" element={<Authentication />} >
          <Route path="/menu/shortvideolist" element={<ShortVideoList />} />
        </Route >


        <Route path="/menu/addshortvideo" element={<Authentication />} >
          <Route path="/menu/addshortvideo" element={<AddShortVideo />} />
        </Route >


        <Route path="/menu/editshortvideo/:id" element={<Authentication />} >
          <Route path="/menu/editshortvideo/:id" element={<EditShortVideo />} />
        </Route >
       
       
        <Route path="/menu/kittigameslist" element={<Authentication />} >
          <Route path="/menu/kittigameslist" element={<KittiGamesList />} />
        </Route >


        <Route path="/menu/addkittigames" element={<Authentication />} >
          <Route path="/menu/addkittigames" element={<AddKittiGames />} />
        </Route >


        <Route path="/menu/editkittigames/:id" element={<Authentication />} >
          <Route path="/menu/editkittigames/:id" element={<EditKittiGames />} />
        </Route >
       
       
        <Route path="/menu/suvicharlist" element={<Authentication />} >
          <Route path="/menu/suvicharlist" element={<SuvicharList />} />
        </Route >


        <Route path="/menu/addsuvichar" element={<Authentication />} >
          <Route path="/menu/addsuvichar" element={<AddSuvichar />} />
        </Route >


        <Route path="/menu/editsuvichar/:id" element={<Authentication />} >
          <Route path="/menu/editsuvichar/:id" element={<EditSuvichar />} />
        </Route >
       
       
        <Route path="/menu/maharajlist" element={<Authentication />} >
          <Route path="/menu/maharajlist" element={<MaharajList />} />
        </Route >


        <Route path="/menu/addmaharaj" element={<Authentication />} >
          <Route path="/menu/addmaharaj" element={<AddMaharaj />} />
        </Route >


        <Route path="/menu/editmaharaj/:id" element={<Authentication />} >
          <Route path="/menu/editmaharaj/:id" element={<EditMaharaj />} />
        </Route >

        


        <Route path="*" element={<PageNotFound />} />



      </Routes>

    </BrowserRouter>
  )
}
export default App
